export class Navigation { 
    key!: number;
    displayValue!: string;
    route!: string;
}